package com.example.borshi.web.auth

/**
 * External interface for Firebase User document (JavaScript interop)
 */
external interface User {
    var uid: String
    var email: String?
    var name: String?
    var phone: String?
    var phoneNumber: String?

    // Referral fields
    var referralCode: String?
    var referredBy: String?
    var referralCount: Int?
    var hasMadePurchase: Boolean?
    var referralBonus: Double?

    // Fraud detection history arrays
    var ipHistory: Array<String>?
    var deviceHistory: Array<String>?
    var addressHistory: Array<String>?

    // Legacy fields (backwards compatibility)
    var lastIp: String?
    var lastDeviceId: String?
    var lastDeliveryAddress: String?
}

// Minimal placeholder for AuthState
sealed class AuthState {
    object Loading : AuthState()
    data class Authenticated(val user: dynamic) : AuthState()
    object Unauthenticated : AuthState()
}

// Minimal placeholder for UserProfile
data class UserProfile(
    val userId: String? = null,
    val phoneNumber: String? = null,
    val email: String? = null,
    val name: String? = null,

    /** True if user has a default address with line1, city, and postalCode populated */
    val hasValidAddress: Boolean = false,

    // Referral fields (added for referral program)
    val referralCode: String? = null,
    val referredBy: String? = null,
    val referralCount: Int = 0,
    val hasMadePurchase: Boolean = false,
    val referralBonus: Double = 0.0,

    // Fraud detection history (enhanced per expert review)
    val ipHistory: List<String> = emptyList(),
    val deviceHistory: List<String> = emptyList(),
    val addressHistory: List<String> = emptyList()
)

// Minimal placeholder for AccountSectionItem
data class AccountSectionItem(
    val title: String,
    val icon: String,
    val id: String
)

// Minimal placeholder for FirebaseTestAccounts
object FirebaseTestAccounts {
    val phoneOtpPairs = listOf<Pair<String, String>>()
    fun hasEntries() = phoneOtpPairs.isNotEmpty()
}
